import { IconActionChevronLeft12, IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';

import * as styles from './VerticalSmallArrow.css';

export interface IVerticalSmallArrowProps {
  direction: -1 | 1;
  offset?: number;
  containerClass?: string;
  positionTop?: string;
  onClick?(): void;
}

const DEFAULT_OFFSET = -14;
const DEFAULT_POSITION_TOP = '50%';

export function VerticalSmallArrow({
  direction,
  offset = DEFAULT_OFFSET,
  containerClass,
  onClick,
  positionTop = DEFAULT_POSITION_TOP,
}: IVerticalSmallArrowProps) {
  const ArrowIcon = direction < 0 ? IconActionChevronLeft12 : IconActionChevronRight12;
  const style = direction < 0 ? { left: `${offset}px`, top: positionTop } : { right: `${offset}px`, top: positionTop };

  return (
    <button className={cx(styles['arrow'], containerClass)} style={style} onClick={onClick}>
      <ArrowIcon color={'icon-secondary-default'} />
    </button>
  );
}
